import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import ImageLoader from '../images/ImageLoader';
import BonusRewardCardModal from './BonusRewardCardModal';

var BonusRewardCard = function BonusRewardCard(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      _props$ctaLinks = props.ctaLinks,
      ctaLinks = _props$ctaLinks === void 0 ? [] : _props$ctaLinks;
  var Image = model.Image,
      Name = model.Name,
      DisplayName = model.DisplayName,
      Description = model.Description,
      Instructions = model.Instructions,
      Expiration = model.Expiration,
      MenuTag = model.MenuTag;
  var modalModel = {
    Image: Image,
    Name: Name,
    DisplayName: DisplayName,
    Description: Description
  }; //state to show modal

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setModal = _useState2[1];

  var _useState3 = useState('/menu'),
      _useState4 = _slicedToArray(_useState3, 2),
      ctaLink = _useState4[0],
      setCtaLink = _useState4[1];

  var hide = function hide() {
    setModal(false);
  };

  var show = function show() {
    setModal(true);
  };

  useEffect(function () {
    if (ctaLinks.length) {
      var _ctaLinkObj$fields, _ctaLinkObj$fields$Li;

      //find menu tag in cta links
      var ctaLinkObj = ctaLinks.find(function (link) {
        var _link$fields, _link$fields$Category, _link$fields$Category2, _link$fields$Category3, _MenuTag$value, _MenuTag$value$toLowe;

        return ((link === null || link === void 0 ? void 0 : (_link$fields = link.fields) === null || _link$fields === void 0 ? void 0 : (_link$fields$Category = _link$fields.Category) === null || _link$fields$Category === void 0 ? void 0 : (_link$fields$Category2 = _link$fields$Category.value) === null || _link$fields$Category2 === void 0 ? void 0 : (_link$fields$Category3 = _link$fields$Category2.toLowerCase()) === null || _link$fields$Category3 === void 0 ? void 0 : _link$fields$Category3.replace(/\s/g, '_')) || 'ctaLink') === ((MenuTag === null || MenuTag === void 0 ? void 0 : (_MenuTag$value = MenuTag.value) === null || _MenuTag$value === void 0 ? void 0 : (_MenuTag$value$toLowe = _MenuTag$value.toLowerCase()) === null || _MenuTag$value$toLowe === void 0 ? void 0 : _MenuTag$value$toLowe.replace(/\s/g, '_')) || 'menuTag');
      });

      if (ctaLinkObj && ((_ctaLinkObj$fields = ctaLinkObj.fields) === null || _ctaLinkObj$fields === void 0 ? void 0 : (_ctaLinkObj$fields$Li = _ctaLinkObj$fields.Link) === null || _ctaLinkObj$fields$Li === void 0 ? void 0 : _ctaLinkObj$fields$Li.value)) {
        setCtaLink(ctaLinkObj.fields.Link.value);
      }
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BonusRewardCardModal, {
    show: showModal,
    hide: hide,
    model: modalModel,
    ctaLink: ctaLink
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-bonus-reward-card",
    onClick: show
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "cb-card__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__body-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__header'
  }, DisplayName.value), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__copy'
  }, Name.value), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__expiration'
  }, Expiration.value && "Expires ".concat(Expiration.value)))));
};

export default BonusRewardCard;